import { z } from "zod";

export const ErpVendorPaymentInformationSchema = z.object({
  id: z.string(),
  paymentInformationId: z.string(),
  isConfirmed: z.boolean(),
  updatedAt: z.preprocess(
    (val) => (val instanceof Date ? val.toISOString() : val),
    z.string().datetime(),
  ),
  createdAt: z.preprocess(
    (val) => (val instanceof Date ? val.toISOString() : val),
    z.string().datetime(),
  ),
  createdBy: z
    .object({
      id: z.string(),
      firstName: z.string(),
      lastName: z.string(),
      email: z.string(),
    })
    .nullable(),
  paymentInformation: z.object({
    id: z.string(),
    accountNumber: z.string(),
    routingNumber: z.string(),
    accountHolderName: z.string(),
    accountHolderType: z.enum(["COMPANY", "INDIVIDUAL"]),
    remittanceEmail: z.string().nullable(),
  }),
  isSharedByVendorCompany: z.boolean(),
});

export type ErpVendorPaymentInformation = z.infer<
  typeof ErpVendorPaymentInformationSchema
>;
